import { forecastSagas } from 'pages/Forecast/_store';
import { improvementsSagas } from 'pages/Improvements/_store';
import { integrationsSagas } from 'pages/Integrations/_store';
import { productivitySagas } from 'pages/Productivity/_store';
import { flexHoursSagas } from 'pages/Time/_store';
import { all, spawn } from 'redux-saga/effects';
import { appSagas } from 'store/glue/app';
import { userSagas } from 'store/glue/user';

import { realtimeSagas } from './page/realtime';
import { zoneManagementSagas } from './page/zoneManagement';

// ! typesafety is not very helpful from this perspective anyway
export function* rootSaga(): any {
  return yield all([
    spawn(appSagas.watcher),
    spawn(flexHoursSagas.watcher),
    spawn(userSagas.watcher),
    spawn(productivitySagas.watcher),
    spawn(forecastSagas.watcher),
    spawn(zoneManagementSagas.watcher),
    spawn(integrationsSagas.watcher),
    spawn(improvementsSagas.watcher),
    spawn(realtimeSagas.watcher),
  ]);
}
